// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "59d89c3628f7df8c505417d41cf916eb" + ".css";
};